import { render, staticRenderFns } from "./plateList.vue?vue&type=template&id=0be29270&scoped=true&"
import script from "./plateList.vue?vue&type=script&lang=ts&"
export * from "./plateList.vue?vue&type=script&lang=ts&"
import style0 from "./plateList.vue?vue&type=style&index=0&id=0be29270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be29270",
  null
  
)

export default component.exports